'use client';

import { useEffect } from 'react';
import log from 'loglevel';

export default function LoggingInitializer() {
  useEffect(() => {
    // Set default level to debug in development, error in production
    const defaultLevel: log.LogLevelDesc = process.env.NODE_ENV === 'development' ? 'debug' : 'error';
    log.setDefaultLevel(defaultLevel);

    const levels = ['trace', 'debug', 'info', 'warn', 'error', 'silent'];

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.code === 'F12') {
        const loglevel = log.getLevel() === 0 ? 5 : log.getLevel() - 1;
        log.setLevel(log.levels.INFO);
        log.info(`[LoggingInitializer] Logging turned to ${levels[loglevel]}`);
        log.setLevel(loglevel as log.LogLevelNumbers);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    // Cleanup listener on component unmount
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []); // Empty dependency array ensures this runs once

  return null; // This component doesn't render anything
}
